<script>
import { Line, mixins } from 'vue-chartjs'
// const brandPrimary = '#20a8d8'
export default Line.extend({
  props: ['height', 'chartData'],
  mixins: [ mixins.reactiveProp ],
  mounted () {
    this.renderChart(this.chartData, {
      tooltips: { enabled: false },
      maintainAspectRatio: false,
      animation: {
        onComplete: function (e) {
          // this.options.animation.onComplete = null
          var imgdiv = document.createElement('div')
          imgdiv.innerHTML = '<div class="print-only"><img width="100%" src="' + e.chart.canvas.toDataURL() + '"/></div>'
          e.chart.canvas.parentNode.parentNode.appendChild(imgdiv)
        }
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          ticks: {
            autoSkip: true
          },
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            display: true,
            beginAtZero: false,
            maxTicksLimit: 5,
            stepSize: 50 // Math.ceil(this.chartData.max / 5),
            // max: Math.ceil(this.chartData.max / 5) * 5 + Math.ceil(this.chartData.max / 5) * 2,
            // min: 0
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          display: false,
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    })
  }
})
</script>


// WEBPACK FOOTER //
// TempCurveChart.vue?7ccb64b8